export enum EImportWordDocumentStage {
  Uploaded,
  Processed,
  LogSaved,
}
